export interface ISearchResponse<T> {
  results: Array<T>;
  totalRecordCount: number;
}

export interface IODataSearchResult<T> {
  '@odata.count': number;
  value: Array<T>;
}

export class SearchResponse<ModelClass> {
  results: Array<ModelClass>;
  totalRecordCount: number;

  constructor(init: { results: Array<ModelClass>; totalRecordCount: number }) {
    this.results = init.results;
    this.totalRecordCount = init.totalRecordCount;
  }
}
